import type { ComponentPropsWithRef } from 'react'

import classNames from 'classnames'

export const Em: React.FC<ComponentPropsWithRef<'em'>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <em
      className={classNames(
        'text-base font-circular-regular text-neutral italic',
        className,
      )}
      {...props}
    >
      {children}
    </em>
  )
}
